import { trans } from '@spotahome/soyuz/client';
import SoyuzAnalytics from '@spotahome/soyuz-analytics';

import { Mediator } from '@spotahome/soyuz-mediator';

import Button from '../Button';
import { CHANNELS } from '../utils/constants';

import styles from './DepositProtectionLabelDescription.module.scss';

const DepositProtectionLabelDescription = () => {
  const handleOnClick = () => {
    SoyuzAnalytics.sendGA4Event('deposit-protection-more', {});
    Mediator.publish(CHANNELS.OPEN_DEPOSIT_PROTECTION_MODAL);
  };

  return (
    <span className={styles['deposit-protection-label-description']}>
      {trans('listing.labels.deposit-protected.description')}{' '}
      <Button color="link" onClick={handleOnClick}>
        {trans('home-ll.cta')}
      </Button>
    </span>
  );
};

export default DepositProtectionLabelDescription;
